// errors-* prefix is swept by rbcOnboarding.i18n.test.js; renaming loses those checks

export const forgotUsernameEn = {
  'forgot-username-heading': 'Recover Your Username',
  'forgot-username-subheader1-text':
    'Enter the 16-digit number on your card. If it is registered, we will email your username to the address on file for the account.',
  'forgot-username-secondary-button': 'Back',
  'forgot-username-email-sent-text':
    'If this card is registered, we\'ve emailed the username to the email address on file for the account. If you no longer have access to that address, contact support. If you didn\'t request this, no action is needed — nobody can sign in with a username alone.',
  'login-subheaderForgotUsername-text':
    'If you forgot your username, click <forgotUsername>here</forgotUsername> to recover it.',
  'errors-captcha_required': 'Please complete the reCAPTCHA and try again.',
  'errors-captcha_invalid': 'reCAPTCHA verification failed. Please try again.',
  'errors-captcha_provider_unavailable':
    'We could not verify the reCAPTCHA right now. Please try again in a few minutes.',
  'errors-rate_limit':
    'Too many attempts. For security, please wait before trying again.',
  'errors-forgot_username_failed': 'Something went wrong. Please try again.',
};

export const forgotUsernameFr = {
  'forgot-username-heading': 'Récupérer votre nom d\'utilisateur',
  'forgot-username-subheader1-text':
    'Saisissez le numéro à 16 chiffres de votre carte. Si elle est enregistrée, nous enverrons votre nom d\'utilisateur à l\'adresse courriel associée au compte.',
  'forgot-username-secondary-button': 'Retour',
  'forgot-username-email-sent-text':
    'Si cette carte est enregistrée, nous avons envoyé le nom d\'utilisateur à l\'adresse courriel associée au compte. Si vous n\'avez plus accès à cette adresse, communiquez avec le soutien. Si vous n\'êtes pas à l\'origine de cette demande, aucune action n\'est requise — personne ne peut se connecter avec un nom d\'utilisateur seul.',
  'login-subheaderForgotUsername-text':
    'Si vous avez oublié votre nom d\'utilisateur, cliquez <forgotUsername>ici</forgotUsername> pour le récupérer.',
  'errors-captcha_required': 'Veuillez remplir le reCAPTCHA et réessayer.',
  'errors-captcha_invalid':
    'La vérification reCAPTCHA a échoué. Veuillez réessayer.',
  'errors-captcha_provider_unavailable':
    'Nous n\'avons pas pu vérifier le reCAPTCHA pour le moment. Veuillez réessayer dans quelques minutes.',
  'errors-rate_limit':
    'Trop de tentatives. Pour des raisons de sécurité, veuillez patienter avant de réessayer.',
  'errors-forgot_username_failed':
    'Une erreur s\'est produite. Veuillez réessayer.',
};
